import {
  greeting,
  skills,
  degrees,
  experience,
  contactPageData,
  personalInfo,
} from "../../portfolio.js";
import projectsData from "../../shared/opensource/projects.json";

export function buildSystemPrompt() {
  // --- IDENTITY & RULES ---
  const identity = `You are Ghassen's AI portfolio assistant. Your ONLY job is to answer questions about Ghassen Ben Nasser based on the data provided below. Rules:
- NEVER invent or guess information not present in this prompt.
- If asked something outside this data (e.g., personal opinions, favorite things, salary expectations), politely say you don't have that info and refer to the contact details.
- Respond in the same language the user writes in (English or French).
- Be concise, friendly, and professional - like a knowledgeable colleague introducing Ghassen to a potential client.
- When listing projects or skills, be specific and reference real details from the data.`;

  // --- PERSONAL OVERVIEW ---
  const langList = personalInfo.languages
    .map((l) => `${l.language} (${l.level})`)
    .join(", ");
  const overview = `
## PERSONAL OVERVIEW
Name: ${greeting.title}
Role: ${greeting.nickname}
Bio: ${greeting.subTitle}
Languages spoken: ${langList}
GitHub: ${greeting.githubProfile}
Portfolio repo: ${greeting.portfolio_repository}`;

  // --- SKILLS ---
  const skillsText = skills.data
    .map((category) => {
      const techList = category.softwareSkills
        .map((s) => s.skillName)
        .join(", ");
      const bulletPoints = category.skills
        .map((s) => s.replace("⚡ ", ""))
        .join("; ");
      return `### ${category.title}\nTech: ${techList}\nHighlights: ${bulletPoints}`;
    })
    .join("\n\n");

  // --- EDUCATION ---
  const educationText = degrees.degrees
    .map((d) => {
      const descs = d.descriptions
        .map((desc) => desc.replace("⚡ ", ""))
        .join("; ");
      return `### ${d.title}\nDegree: ${d.subtitle}\nDuration: ${d.duration}\nDetails: ${descs}`;
    })
    .join("\n\n");

  // --- WORK EXPERIENCE & INTERNSHIPS ---
  const experienceText = experience.sections
    .map((section) => {
      const header = `### ${section.title}`;
      const entries = section.experiences
        .map(
          (e) =>
            `- ${e.title} @ ${e.company} (${e.duration}, ${e.location})\n  ${e.description}`
        )
        .join("\n");
      return `${header}\n${entries}`;
    })
    .join("\n\n");

  // --- PROJECTS ---
  const projectsText = projectsData.data
    .map((p) => {
      const tech = p.languages.map((l) => l.name).join(", ");
      return `PROJECT: ${p.name}\nURL: ${p.url}\nTECH: ${tech}\nDESCRIPTION: ${p.description}`;
    })
    .join("\n\n");

  // --- CONTACT ---
  const contactText = `
## CONTACT
Email: ghassennasser8@gmail.com
Phone: ${contactPageData.phoneSection.subtitle}
Location: ${contactPageData.addressSection.subtitle}
Upwork: ${contactPageData.blogSection.link}
Available for: AI chatbot builds, full-stack products, and mobile apps.`;

  return `${identity}
${overview}

## SKILLS
${skillsText}

## EDUCATION
${educationText}

## WORK EXPERIENCE & INTERNSHIPS
${experienceText}

## PROJECTS (${projectsData.data.length} total)
${projectsText}
${contactText}`;
}
